import { render } from "./licenseTotalDetailedView.vue?vue&type=template&id=bb59c5e2&scoped=true"
import script from "./licenseTotalDetailedView.vue?vue&type=script&lang=js"
export * from "./licenseTotalDetailedView.vue?vue&type=script&lang=js"

import "./licenseTotalDetailedView.vue?vue&type=style&index=0&id=bb59c5e2&lang=scss&scoped=true"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb59c5e2"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
